import Website from "./objects/Website";
import {getWebsite, hasWebsite, visitorHasScrolled} from "./functions/website";

window.addEventListener('load', () => {
    if (!hasWebsite()) {
        return false;
    }

    const website = new Website(getWebsite());

    website.init();
    website.checkRowsForVisibility(
        (window.scrollY + window.innerHeight)
    );
    website.checkScrollPositionForHeaderStyle(window.scrollY);

    window.addEventListener('scroll', () => {
        website.checkScrollPositionForHeaderStyle(window.scrollY);
    });

    window.addEventListener('scroll', () => {
        website.checkRowsForVisibility(
            (window.scrollY + window.innerHeight)
        );
    });
});